import { render, staticRenderFns } from "./MenuChildrenItem.vue?vue&type=template&id=0b4cc7c2&scoped=true&"
import script from "./MenuChildrenItem.vue?vue&type=script&lang=js&"
export * from "./MenuChildrenItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuChildrenItem.vue?vue&type=style&index=0&id=0b4cc7c2&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4cc7c2",
  null
  
)

export default component.exports